var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "info-wrapper" }, [
    _c("div", [_vm._v(_vm._s(_setup.texts.faq.q2))]),
    _c("div", { staticClass: "info-message" }, [
      _c("span", { class: [_setup.Icons.INFO_FULL, "icon"] }),
      _c("span", { staticClass: "message" }, [
        _vm._v(" " + _vm._s(_setup.texts.faq.q1) + " "),
        _c("br"),
        _vm._v(" " + _vm._s(_setup.texts.faq.q3) + " "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }